import {
  DOCUMENT_REPOSITORIES_ENTITY_NAME,
  OPTION_STORE_ENTITY_NAME,
  REPORT_MODELS_SMARTINSIGHT_TYPE,
  REPORTS_SMARTINSIGHT_TYPE,
  SAVED_SEARCH_ENTITY_NAME,
  SAVED_SEARCH_LIST_SEARCH_NAME,
  SAVED_SEARCHES_SMARTINSIGHT_TYPE,
  SMARTINSIGHT_REPORT_LIST_SEARCH_NAME,
  SMARTINSIGHT_REPORT_MODELS_SEARCH_NAME,
} from '../constants/SmartInsightConstants';
import { STANDALONE_DASHBOARD_TYPES } from '../constants/StandaloneLayoutConstants';
import {
  REPORT_MODEL_DESIGNER,
  SAVED_SEARCH_EDITOR,
  SMART_INSIGHT_REPORTS,
} from '../constants/Urls';

export const getSmartInsightDashboardConfig = (smartInsightType, translateString) => {
  switch (smartInsightType) {
    case REPORT_MODELS_SMARTINSIGHT_TYPE:
      return {
        title: translateString('Report Models'),
        entityName: OPTION_STORE_ENTITY_NAME,
        searchName: SMARTINSIGHT_REPORT_MODELS_SEARCH_NAME,
        navigationColumnPathname: REPORT_MODEL_DESIGNER,
        type: STANDALONE_DASHBOARD_TYPES.REPORT_MODELS,
        sortExpressionColumn: 'OPS_MODIFIED_DATE DESC',
        documentTitle: translateString('SmartInsight Report Models'),
      };

    case SAVED_SEARCHES_SMARTINSIGHT_TYPE:
      return {
        title: translateString('Saved Searches'),
        entityName: SAVED_SEARCH_ENTITY_NAME,
        searchName: SAVED_SEARCH_LIST_SEARCH_NAME,
        navigationColumnPathname: SAVED_SEARCH_EDITOR,
        type: STANDALONE_DASHBOARD_TYPES.SAVED_SEARCHES,
        sortExpressionColumn: 'QYD_MODIFIED_DATE DESC',
        documentTitle: translateString('Saved Searches'),
      };

    case REPORTS_SMARTINSIGHT_TYPE:
    default:
      return {
        title: translateString('Reports'),
        entityName: DOCUMENT_REPOSITORIES_ENTITY_NAME,
        searchName: SMARTINSIGHT_REPORT_LIST_SEARCH_NAME,
        navigationColumnPathname: SMART_INSIGHT_REPORTS,
        type: STANDALONE_DASHBOARD_TYPES.REPORTS,
        sortExpressionColumn: 'QYD_MODIFIED_DATE DESC',
        documentTitle: translateString('SmartInsight Reports'),
      };
  }
};

export const modifyRecentItems = ({ items, smartInsightType }) => {
  switch (smartInsightType) {
    case SAVED_SEARCHES_SMARTINSIGHT_TYPE:
      return items.map((item) => ({
        id: item.QYD_ID,
        name: item.QYD_QUERY_NAME,
        entityName: item.EntityName,
        entityViewName: item.HdrName,
        navigationParams: item.NavigationColumnParams,
      }));

    case REPORT_MODELS_SMARTINSIGHT_TYPE:
      return items.map((item) => ({
        id: item.OPS_ID,
        name: item.OPS_KEY,
        version: item.OPS_VERSION,
        releaseType: item.OPS_RELEASE_TYPE,
      }));

    case REPORTS_SMARTINSIGHT_TYPE:
    default:
      return items.map((item) => ({
        id: item.QYD_ID,
        name: item.QYD_QUERY_NAME,
      }));
  }
};

export const getLinkToLegacyReportViewer = (pathname, reportId, token) =>
  `https://${pathname}/adhocreportviewer.aspx?reportId=${reportId}&Token=${token}`;
